export const InjectionNames = {
  eventBus: 'eventBus',
  bpmnFactory: 'bpmnFactory',
  elementRegistry: 'elementRegistry',
  elementFactory: 'elementFactory',
  translate: 'translate',
  propertiesProvider: 'propertiesProvider',
  bpmnPropertiesProvider: 'bpmnPropertiesProvider',
  paletteProvider: 'paletteProvider',
  originalPaletteProvider: 'originalPaletteProvider',
  customRenderer: 'CustomRenderer',
  connectionPreview: 'ConnectionPreview',
  originalRenderer: 'originalRenderer',
  commandStack: 'commandStack',
  moddle: 'moddle',
  modeling: 'modeling',
  autoPlace: 'autoPlace',
  rules: 'rules',
  pathwaysModeling: 'pathwaysModeling',
  pathwaysViewerCommands: 'pathwaysViewerCommands',
  textRenderer: 'textRenderer',
  treeNavigator: 'treeNavigator',
  treePathNavigator: 'treePathNavigator',
  dimNodesService: 'dimNodesService',
  shapeFocus: 'shapeFocus',
  overlays: 'overlays',
  zoomService: 'zoomService',
  neighborhoodHeadNameUpdater: 'neighborhoodHeadNameUpdater',
  dimensionsCalculator: 'dimensionsCalculator',
  treeToScreenFitter: 'treeToScreenFitter',
  contextPad: 'contextPad',
  selection: 'selection',
  canvas: 'canvas'
};

export const EventType = {
  IMPORT_DONE: 'import.done',
  NODE_ADDED: 'node.added',
  NODE_UPDATED: 'node.updated',
  SHAPE_REMOVED: 'shape.removed',
  SHAPE_ADDED: 'shape.added',
  GUIDEBOX_OVERLAY_ADDED: 'guidebox.added',
  GUIDEBOX_DATA_REMOVED: 'guidebox.data.removed',
  NODE_REMOVED: 'node.removed',
  CONNECT_END: 'connect.end',
  SHAPE_REPLACE: 'shape.replace',
  UPDATE_LABEL: 'element.updateLabel',
  IMPORT_PARSE_COMPLETE: 'import.parse.complete',
  SHAPE_RENDERED: 'shape.rendered',
  SAVE_START: 'save.start',
  START_PREVIEW: 'start.preview',
  SHAPE_APPEND: 'shape.append',
  MARKED_DELETED_NODE: 'marked.deleted.node',
  MARKED_DELETED_CONNECTION: 'marked.deleted.connection',
  FLOATED_NODES_ADDED: 'floated.nodes.added',
  FLOATED_NODES_REMOVED: 'floated.nodes.removed',
  SELECTION_CHANGED: 'selection.changed',
  TOGGLE_SPINNER: 'toggle.spinner',
  AFTER_PARSE_COMPLETE: 'after.parse.complete',
  ELEMENT_DBLCLICK: 'element.dblclick',
  ELEMENT_CLICK: 'element.click',
  CONNECT_OUT: 'connect.out',
  CONNECT_CLEANUP: 'connect.cleanup',
  OPEN_DELETE_WARNING: 'open.delete.warning',
  OPEN_PANEL: 'open.panel'

};

export const CommandType = {
  SET_ELEMENT_VISIBILITY: 'element.hide',
  SUBPROCESS_CREATE_CHILDREN: 'subprocess.create.children',
  NODE_CREATE_DATA: 'node.create.data',
  NODE_UPDATE_DATA: 'node.update.data',
  CONNECTION_APPEND_EXPRESSION: 'connection.append.expression',
  CALCULATE_CHILDS_DATA: 'node.calculate.childs.data',
  NODE_CLEAR_DATA: 'node.clear.data',
  NODE_RESET_CHILDREN_DATA: 'node.reset.children.data',
  NODE_RESET_DATA: 'node.reset.data',
  REMOVE_NODE: 'node.remove',
  APPEND_NODE: 'node.append',
  PROCESS_BPMN_FOR_APPROVAL: 'process.final.deployment',
  MARK_NODE_DELETED: 'mark.node.deleted',
  MARK_CONNECTION_DELETED: 'mark.connection.deleted',
  EDIT_NODE_NAME: 'edit.node.name',
  SHAPE_REPLACE: 'shape.replace',
  NAVIGATE_TO_NODE: 'navigate.to.node',
  NAVIGATE_TO_NODE_WITH_DATA: 'navigate.to.node.with.data',
  RENDER_ELEMENT: 'render.element',
  NODE_COPY: 'node.copy',
  NODE_PASTE: 'node.paste',
  REMOVE_CONNECTION: 'connection.remove',
  CONNECTION_APPEND: 'connection.append',
  TOGGLE_FLOATING_NODES: 'toggle.floating.nodes',
  ELEMENTS_MOVE: 'elements.move',
  NODE_HIERARCHY_COPY: 'node.hierarchy.copy',
  BACKUP_AND_RESTORE_BPMN_BEFORE_APPROVAL: 'backup.and.restore.before.approval'};

export const UserInitiatedCommandType = {
  APPEND_NODE: 'node.append',
  REMOVE_NODE: 'node.remove',
  NODE_CLEAR_DATA: 'node.clear.data',
  CONNECTION_APPEND: 'connection.append',
  REMOVE_CONNECTION: 'connection.remove',
  NODE_PASTE: 'node.paste',
  ELEMENTS_MOVE: 'elements.move'
};
